import { FC } from 'react'
import { Button, Tooltip } from 'antd'
import Task from '../../../types/api/task'
import CompleteDigitalDismountingTask from '../../../components/tasks/complete-digital-dismounting-task'
import CompleteDrawingBlank from './complete-drawing-blank'
import CopmleteDrawingStamp from './copmlete-drawing-stamp'
import CompleteAssemblyPrep from './complete-assembly-prep'
import CompleteFormsOrder from './complete-forms-order'
import CompleteHonestSign from './complete-honest-sign'
import { isShipmentAwaitingCuratorApproval } from '../../../helpers/entities/shipment/curator-approval'

interface CompleteTaskProps {
    task: Task
}

const CompleteTask: FC<CompleteTaskProps> = ({ task }) => {
    const blockedUntilCuratorApproval =
        task.type !== 'Отрисовка бланка' && isShipmentAwaitingCuratorApproval(task.shipment)

    if (blockedUntilCuratorApproval) {
        return (
            <Tooltip title='Ожидается согласование задания куратором'>
                <span>
                    <Button size='small' disabled>
                        Завершить
                    </Button>
                </span>
            </Tooltip>
        )
    }

    const map: { [key: string]: JSX.Element } = {
        'Отрисовка бланка': <CompleteDrawingBlank task={task} />,
        'Отрисовка штампа': <CopmleteDrawingStamp task={task} />,
        'Подготовка сборки': <CompleteAssemblyPrep task={task} />,
        'Внесение правок': <CompleteAssemblyPrep task={task} />,
        'Заказ форм': <CompleteFormsOrder task={task} />,
        'Перезаказ форм': <CompleteFormsOrder task={task} />,
        'Цифровой спуск': <CompleteDigitalDismountingTask task={task} />,
        'Честный знак': <CompleteHonestSign task={task} />,
    }
    return map[task.type] || null
}

export default CompleteTask
